var map = {
	"./1 - BLT.jpg": 5154,
	"./1 - Breakfast Bacon Croissant.jpg": 11266,
	"./1 - Breakfast Croissant Sandwich.jpg": 61932,
	"./1 - FAJITAS.jpg": 27372,
	"./1 - Pulled Pork Sliders.jpg": 81782,
	"./1 - QUESADILLA.jpg": 28517,
	"./1 - SANDWICH.jpg": 18329,
	"./1 - TACO.jpg": 63237,
	"./1 - Turkey Wrap.jpg": 63198,
	"./1 - bagel.jpg": 9361,
	"./1 - breakfast burritos.jpg": 28385,
	"./1 - breakfast sandwich.jpg": 17876,
	"./1 - chicken quesadilla.jpg": 48406,
	"./1 - fish tacos tempura.jpg": 84030,
	"./1 - fish tacos.jpg": 25966,
	"./1 - fried shrimp taco.jpg": 79234,
	"./1 - fundadores.jpg": 52867,
	"./1 - gaviotta.jpg": 1461,
	"./1 - muffin sandwich.jpg": 78210,
	"./1 - quesadillas.jpg": 36158,
	"./1 - shrimp ceviche.jpg": 35744,
	"./1 - shrimp taco grilled.jpg": 4263,
	"./1 - spring rolls.jpg": 64821,
	"./1 Chesse Quesadillas.jpg": 39262,
	"./1 Chicken Club Wrap.jpg": 81752,
	"./1 Chicken Fingers.jpg": 29922,
	"./1 Egg Ham and Cheese.jpg": 91116,
	"./1 Ham Egg and Cheese.jpg": 14528,
	"./1 Honey Chicken Wrap.jpg": 82725,
	"./1 Turkey on Rye.jpg": 96432,
	"./1 Turkey on Sourdough.jpg": 71164,
	"./1 Turkey sandwich-2.jpg": 28833,
	"./1 chicken breast sandwich.jpg": 9818,
	"./1 chicken fingers with fries.jpg": 71597,
	"./1-blt.jpg": 13756,
	"./1-brat.jpg": 32151,
	"./1-burger-1.jpg": 30257,
	"./1-burger-2.jpg": 72486,
	"./1-burger-3.jpg": 11011,
	"./1-club.jpg": 8988,
	"./1-eggsalad.jpg": 65118,
	"./1-grilledcheese.jpg": 61258,
	"./1-ham.jpg": 65260,
	"./1-hotdog.jpg": 16069,
	"./1-melt.jpg": 5590,
	"./1-reuben.jpg": 3799,
	"./1-roastbeef.jpg": 21023,
	"./1-tunasalad.jpg": 23179,
	"./1-turkey.jpg": 53318,
	"./2 - FRUIT.jpg": 71209,
	"./2 - Fresh Fruit.jpg": 47645,
	"./2 - calimari.jpg": 77283,
	"./2 - gucamole.jpg": 49226,
	"./2 - yogurt granola cup.jpg": 70661,
	"./2 -ceviche.jpg": 61336,
	"./2-chips-1.jpg": 84218,
	"./2-chips-2.jpg": 88421,
	"./2-chips-3.jpg": 44456,
	"./2-fries-1.jpg": 46014,
	"./2-fries-2.jpg": 25609,
	"./2-rings.jpg": 99060,
	"./2-salad.jpg": 77110,
	"./3 Bloody Mary.jpg": 23069,
	"./3 Fat Tire.jpg": 21174,
	"./3 Greyhound.jpg": 44018,
	"./3 Newcastle.jpg": 77509,
	"./3 Vodka Cranberry.jpg": 2490,
	"./3-beer-1.jpg": 76434,
	"./3-beer-2.jpg": 95389,
	"./3-beer-3.jpg": 69824,
	"./3-beer-4.jpg": 10131,
	"./3-beer-5.jpg": 38518,
	"./3-beer-6.jpg": 88129,
	"./3-beer-7.jpg": 10084,
	"./3-beer-8.jpg": 98295,
	"./3-soda-1.jpg": 11615,
	"./3-soda-2.jpg": 13616,
	"./3-soda-x.jpg": 7178,
	"./3-x-1.jpg": 90478,
	"./3-x-2.jpg": 89145,
	"./3-x-3.jpg": 44796,
	"./3-x-4.jpg": 15559,
	"./3-x-5.jpg": 3402,
	"./3-x-6.jpg": 27541,
	"./3-x-7.jpg": 82712,
	"./4 - CHIPS.jpg": 15092,
	"./4 - CIGARETTES.jpg": 70526,
	"./4 - GRANOLA.jpg": 57357,
	"./4 - OREO.jpg": 15982,
	"./4 - PISTACHIOS.jpg": 45174,
	"./4 - PRINGLES.jpg": 44495,
	"./4 - RITZ.jpg": 41056,
	"./4-A_Pastry.jpg": 74256,
	"./4-bagel.jpg": 22770,
	"./4-candy.jpg": 1996,
	"./4-nuts.jpg": 37195,
	"./4-popcorn.jpg": 33320,
	"./4-pretzels.jpg": 51722,
	"./TournamentWelcome.jpg": 77959,
	"./Ver-4.txt": 38354,
	"./white.jpg": 455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17584;